module.exports = __webpack_public_path__ + "static/img/banner1.76c11293.png";